// This file is auto-generated don't edit it!
import { Component } from '@angular/core';

@Component({
    selector: 'ui-dialog-docs',
    templateUrl: './dialog.docs.generated.html',
})
export class UIDialogDocs { }
